import useSWR from 'swr'

import {
  GetRelayHealthResponse,
  ListRelayLogsResponse,
  ListRelayLogsVars,
  RelayApiPath
} from '@/common/api/params/relay'

import { BadgeType } from '@/components/view/atoms/badge/Badge'

export const useRelayHealthApi = () => {
  return useSWR<GetRelayHealthResponse, Response, string>(RelayApiPath.GET_RELAY_HEALTH, {
    refreshInterval: 30000
  })
}

export const useRelayLogsApi = (vars: ListRelayLogsVars) => {
  return useSWR<ListRelayLogsResponse, Response, [string, ListRelayLogsVars]>([
    RelayApiPath.LIST_RELAY_LOGS,
    vars
  ])
}

// FTP 連携（リレーサーバーからの転送）のログの状態の表示

export const relayStatusBadgeType = (status: string): BadgeType => {
  switch (status) {
    case 'forwarded':
      return BadgeType.SUCCESS
    case 'retrying':
      return BadgeType.CAUTION
    case 'failed':
      return BadgeType.CRITICAL
    default:
      return BadgeType.DEFAULT
  }
}

export const relayStatusLabel = (status: string): string => {
  switch (status) {
    case 'forwarded':
      return '転送成功'
    case 'retrying':
      return 'リトライ中'
    case 'failed':
      return '転送失敗'
    default:
      return status
  }
}
